var _use, _use2, _image, _image2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRhAppFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-.21.687C-.143.691.158.371.213.356h.001L.218.355h.001C.284.348.502.46.549.452.597.444.802.253.802.253l.154-.306-.151-.335-.598-.259c-.058-.025-.535.273-.579.362-.043.089-.043.349-.057.391-.014.044-.28.408-.28.408s.432.168.499.173Z",
    style: {
      fill: "url(#a)",
      fillRule: "nonzero"
    },
    transform: "scale(-23.19478) rotate(-23.452 -11.002 5.874)"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 56.898,
    y: 87.981,
    width: 21.435,
    height: 21.2,
    transform: "matrix(.97432 0 0 .96366 0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.288.928c-.84-.279-1.177.708-1.177.708l2.224.114C1.431.627.713-1.358.243-1.673a.222.222 0 0 0-.107-.041C-.225-1.732-.189-.32.288.928Z",
    style: {
      fill: "url(#c)",
      fillRule: "nonzero"
    },
    transform: "matrix(4.06799 -.20862 .20862 4.06799 39.208 99.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.139-.181c.008.037.115.334.115.334l-.094.095a3.076 3.076 0 0 0-.149.157.532.532 0 0 0-.021.214c.014.009.106.03.116.013A.818.818 0 0 0-.155.484S-.068.442.018.397A1.04 1.04 0 0 0 .184.301C.202.274.208.122.175-.015c.073.008.173.01.279.009.266-.003.568-.024.568-.024l.136-.367S.814-.65.748-.654C.683-.657.401-.627.401-.627l-.045.01-.228.051s-.239.304-.265.374c-.002.005-.002.009-.002.011Z",
    style: {
      fill: "url(#d)",
      fillRule: "nonzero"
    },
    transform: "scale(26.68158) rotate(69.759 -1.516 2.448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.281.464C.767.356 1.314.199 1.314.199l.082-.567c-.763-.054-1.5.077-1.741.457a.825.825 0 0 0 .626.375Z",
    style: {
      fill: "url(#e)",
      fillRule: "nonzero"
    },
    transform: "rotate(81.781 -27.712 69.603) scale(14.22764)"
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 37.97,
    y: 87.231,
    width: 21.334,
    height: 22.114,
    transform: "matrix(.96972 0 0 .96147 0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.836-.142-.649.035-.385.021.008.088s.171.034.359.065C.368.1.586.13.63.115.716.084.858-.063.858-.063L.836-.142Z",
    style: {
      fill: "url(#g)",
      fillRule: "nonzero"
    },
    transform: "scale(27.1038) rotate(-85.2 2.953 .848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.148.262 1.005.135.968-.129S.446-.201-.121-.262c-.069.143-.05.367-.034.482l.007.042Z",
    style: {
      fill: "url(#h)",
      fillRule: "nonzero"
    },
    transform: "rotate(97.989 -17.185 70.385) scale(9.00567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.19.774h.558S.756-.779.454-.771H.45C.151-.752.19.774.19.774Z",
    style: {
      fill: "url(#i)",
      fillRule: "nonzero"
    },
    transform: "rotate(3.73 -1465.998 877.322) scale(8.61814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.941 1.279v-2.423S-.088-1.291-.088.033c0 1.323 1.029 1.246 1.029 1.246Z",
    style: {
      fill: "url(#j)",
      fillRule: "nonzero"
    },
    transform: "rotate(90 -22.477 80.168) scale(3.54643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.319.364c.209-.012.449-.035.683-.08 0 0 .069-.227.024-.385C.806-.32.404-.357.245-.29a.378.378 0 0 0-.088.064C-.029-.055-.32.371-.32.371s.274.014.639-.007Z",
    style: {
      fill: "url(#k)",
      fillRule: "nonzero"
    },
    transform: "scale(-26.1601) rotate(-60.368 -2.479 1.724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.79.436.841.265l.076-.557-.089-.144C.501-.285-.08.167-.08.167s.366.138.87.269Z",
    style: {
      fill: "url(#l)",
      fillRule: "nonzero"
    },
    transform: "rotate(101.821 25.622 40.367) scale(18.32956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.114-.821c-.106.038-.26.106-.356.194-.072.423.187.903.356 1.021.097.068.555.13 1.011.161A10.104 10.104 0 0 0 .114-.821Z",
    style: {
      fill: "url(#m)",
      fillRule: "nonzero"
    },
    transform: "scale(-16.31995) rotate(61.701 .337 -4.943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.036.079C.152.175.259.247.353.29c.219.099.787-.168.787-.168L1.042-.33a5.957 5.957 0 0 0-.804-.113 2.64 2.64 0 0 0-.711.031c.18.193.353.363.509.491Z",
    style: {
      fill: "url(#n)",
      fillRule: "nonzero"
    },
    transform: "rotate(77.471 -4.944 31.922) scale(23.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.031.491.084-.214-.037-.516-.136-.252C.549-.328.145-.124-.155.113c.435.166.84.298 1.186.378Z",
    style: {
      fill: "url(#o)",
      fillRule: "nonzero"
    },
    transform: "rotate(103.815 9.968 23.503) scale(13.10459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.005-.19c-.123.065-.285.471-.358.743L.005.66C.183.505.695.041.992-.419.417-.353.139-.26.005-.19Z",
    style: {
      fill: "url(#p)",
      fillRule: "nonzero"
    },
    transform: "scale(18.9957) rotate(-50.359 3.087 -.442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.41.513c.052.127.48.483.721.618.03.017.057.03.08.039.348-.197.643-1.116.643-1.116S.923-.676.523-1.17a.862.862 0 0 0-.103.037c-.312.134-.718.464-.756.54-.036.071-.105.7-.092.985A.41.41 0 0 0-.41.513Z",
    style: {
      fill: "url(#q)",
      fillRule: "nonzero"
    },
    transform: "scale(-20.1685) rotate(-87.397 -2.657 -.274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.129.686c.078.127.599.436.882.54A7.87 7.87 0 0 0 .966.4C.873.36.604.24.587.206.567.164.551-.108.572-.147c.016-.031.216-.202.301-.274a8.939 8.939 0 0 0-.135-.805c-.312.197-.691.622-.719.71-.027.083.007.77.07 1.075a.486.486 0 0 0 .04.127Z",
    style: {
      fill: "url(#r)",
      fillRule: "nonzero"
    },
    transform: "scale(-18.53389) rotate(-78.311 -2.978 .253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-2.532 2.684-4.917 2.684c-2.384 0-4.32-4.173-4.32-4.173S-5.218-2.684 0 0",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "translate(49.125 61.234) scale(.69987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.762.758c.381-.246.658-.518.67-.776.012-.242-.344-.521-.785-.763a7.034 7.034 0 0 0-1.378-.57c1.023.776.551 2.482.257 2.703A6.45 6.45 0 0 0 .762.758Z",
    style: {
      fill: "url(#s)",
      fillRule: "nonzero"
    },
    transform: "matrix(-.62584 4.14619 -4.14619 -.62584 44.628 69.887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.627C.873-.688 1.943.792 3.131 1.03c1.119.225 2.662-1.234 4.1-3.113C4.976-3.882 1.599-3.135 0-2.627",
    style: {
      fill: "#de3657",
      fillRule: "nonzero"
    },
    transform: "translate(41.706 74.423) scale(.69987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.534C.373 0-1.341.597-2.31 1.193c.969 0 2.31 1.341 2.31 1.341",
    style: {
      fill: "#670b32",
      fillRule: "nonzero"
    },
    transform: "translate(51.16 66.867) scale(.69987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .447c-1.788-.671-2.086 1.416-2.086 1.192 0-.223-.522-1.714.447-2.384C-.671-1.416 0 .447 0 .447",
    style: {
      fill: "#670b32",
      fillRule: "nonzero"
    },
    transform: "translate(40.312 67.18) scale(.69987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.287 3.812h.85l1.31-7.907-.594-.086-1.566 7.993Z",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "matrix(-.18443 .67513 .67513 .18443 35.876 64.049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.421C.522 4.77.969.746-1.788.373-4.546 0-5.216 3.503-5.291 8.123c.894.298 5.291.298 5.291.298",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "translate(38.904 55.393) scale(.69987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.755-.388H.108L.023.801l-7.9-.525.122-.664Z",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "matrix(-.6981 -.04976 -.04976 .6981 52.624 62.084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.24S1.118.596-2.683.298C-6.483 0-5.44 9.017-5.44 9.017L0 9.24Z",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "translate(57.053 55.915) scale(.69987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.888 2.479h.973l.68-3.984-.897-.394-.756 4.378Z",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "matrix(-.37584 .5904 .5904 .37584 54.66 54.446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36-1.585h.973l.68 3.984-.897.394-.756-4.378Z",
    style: {
      fill: "#211628",
      fillRule: "nonzero"
    },
    transform: "matrix(.37584 .5904 .5904 -.37584 36.564 50.605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.267-1.267a1.267 1.267 0 1 1 0 2.533 1.267 1.267 0 0 1 0-2.533",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(0 .69987 .69987 0 36.818 56.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.267-1.267a1.267 1.267 0 1 1 0 2.533 1.267 1.267 0 0 1 0-2.533",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(0 .69987 .69987 0 54.55 57.375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.306 1.081C1.129.744.861-.426 1.072-1.081.988-.947-.236.058-.236.058s1.319.95 1.542 1.023Z",
    style: {
      fill: "url(#t)",
      fillRule: "nonzero"
    },
    transform: "rotate(142.046 29.582 51.592) scale(6.61427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.281-.129c-.016-.068-.247-.406-.33-.383-.083.024-.488.423-.488.423S.061-.208-.343-.318c-.072.209-.166.595-.003.875C.049.538.515.51.591.493A.184.184 0 0 0 .629.477c.18-.092.667-.543.652-.606Z",
    style: {
      fill: "url(#u)",
      fillRule: "nonzero"
    },
    transform: "rotate(-152.784 21.967 38.126) scale(6.15787)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 .02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 .018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 -.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 .042)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb8a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 -.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#681150",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1 -1) rotate(-89.392 .461 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 .066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 .028)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#681150",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1 1) rotate(-60.77 0 .553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb8a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 -.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#681150",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1 1) rotate(48.139 0 -.553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb8a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb8a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8239",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e63333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#740042",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ffe3b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbb8a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 .022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#801f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#681150",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACQUlEQVQ4jY2Vz2oUQRDGf9XTu1FEUJ8rL+BBH0CIiIjg1YPowZvgzbPgQZQg5Cly8WBkz0lg2cS4k7873Z+H+dc9OyEO1NDVXV31VdXX3SaJ9NPFueL8gDg/IC4OiYtDtNhHx/vY3wMm1YlZAa1QWD12mRt8qlSzXzp6+Rhnqo1948Cg2DCmt52pMBCdWDsefH0cieXHt1hsrATEWgzDF67TM5H6QGOOz3e+a7X3M0PTivMGYBJIqn21EntZK4XOTrX89KFedIJoYL3jwtlowF4EamwsQXz27Qvx5LhPv90QG4OIjaWvSI4+KYenqii/fq4nRxCYM5QiaoNb3dR2jDUwG9TubOeHwnyeI027zvh81rS29rFH7Ve/9/INDQI1KLrGpLV3IwBSHfCxXOZloDUcTz8bD8X1e3xYln1qLaKEEQoNdxobpcGuC27gVJbjHY513UJQtrbGnGtq70JZJqXIG0KEGAChnG43U8+rPK0NkoYMqVdVwneH5P+o1yHuj6bWUg2VIKKb0k+p51Uu1xgxRBMDrK4iE+f67t9APXf34aPRo9mBaH4hQKiksWM/Ju7e1pbdf/o8b4w00GupVqK6ikKI4S030K19QU63t/Xn3WsggANrX4bmdajH9ZzzMLllFBNn5pIHIdnT3cd3NjftwZv3MJmOUy9tToDVRaS6lDIqJtSz4Zt3uburo1fP0EWJFQYZ4gZVorvCKKbgp4abmHWoh44BVrOZFi+eEE8WeUmK+hrN9KRczht+wygmjn+mlhMi2jjBaAAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "f",
    width: 22,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAYAAAAP6L+eAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADYklEQVQ4jYWUy28cRRCHv+qd8drxY20SOxsTiJCTKFIgipCVhLflKwIFiXBAQso1dw5InDhy4ARIHLlwAGQ4IA4+ISHxFyBjOwlEFnECDvFjn7M73V0cenZ2x06clko9j+6vf/OrqpH0wyuoAr2oniR+7zpEMQCoJ/3hW9z6KiiFtaqABz//lo7d+FgYGEYrs6oO1IGqEL15rQ8FEEN89Rry7Bz5uixwineqteUl7MZfWgBzfgF1ijrFnH0BqUxyYJQiht5+BzUxOPL16sB2FDzUv/+6sMWYC4uoQ9VB6fKrB6E94RMTRJeu5MBe2K5HLbR/XcZvP8xVm9LceXHjVTQqIzPHHwsGiF9/Dcoj+8CKevCdlPrSNwCk639gAMzzC8jE1KFQABkeJl54I4d6i6Zdj3pFvVL/eQlNEq19+WkAR/OL6PhUwXw0S7v34B04B84ydGkemaigTkk7LhziQ7hajZ3PPyNdWwng+NwFsVMn8s1YW5x7z50FUcoLr6AO0ixxg9Y0ln9CFaLc7OmnwVpFkFCg9ItWKczxudN4J5kN/dco+CTBx0YNAN0W0fovpLutw9VmIcMxemwan9lAVtO4kEjb1WAFrT3i5j1JVm6iaaoFUH5Q0SadnR2Aae6zZssC2DtEwPy5Qvdhc0DlQbU4h20kaqrVAiwPHywJ4KEREIi2N+hsPkA7XT1MbWerSWl6CikPh9b2FA7pg8eOwugkoKK3b5FsNR+vtp6obXXBO6JnZvcpVvCKkR4YoHoaBMydm6Q7TWwt0QNqrdXkvyZ4C94ydOp4aHE/4LMj2Jp31YmziICkiejdu7Tu17HNjg6qbW81cK1Ofh8dnXikx1KSAcVnXg5HCfi126hNaW3Waf9T1+5OW5ubNe3utQudaMbKubdkpS8iGETyBuHURaRyDLa30K0Horu7yvg43Vo60CC9rg+zGCiNjuAa7f7/JAr91VcsBnNxsScat7qRebmvjij+UkqVI4X7ytV3keEjGbi5A/dWkaeqgSpg1/4OiXvCMJP7wB+8z8wXXxFx6zf48RPoNHB7GsAGSK24O/e1dObkoeCoMtq/nplhaO45ATB89xF0GsENCeaHGezvG09UXBoAj7w43/8S/MDnSjHcv3via/3EPBI82QePvnQ5v/4f0tR8An3a6dQAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhAppFox);
export default __webpack_public_path__ + "static/media/RhAppFox.4a1c7584c42973b84f484f2f069cd76f.svg";
export { ForwardRef as ReactComponent };